import React, { Component } from 'react';
import API from '../../../utils/API';
import FilesUploadModal from './modals/filesUploadModal';
import RemoveFilesModal from './modals/removeFilesModal';
import AddFolderModal from "./modals/addFolderModal";

import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import TabsContainer from '../../../components/views/TabsContainer';


import SectionHeader from '../../../components/views/SectionHeader';
import LoadingWizard from '../../../components/spinner/wizard';
import FileGrid from '../../../components/tables/FileGrid';
import ViewsTable from '../../../components/tables/ViewsTable';
import ViewsTableAssets from "../../../components/tables/ViewsTableAssets";

class EventFiles extends Component {
	constructor(props) {
		super(props);
		const columns = {
			name: 'Name',
			dimensions: 'Image Dimensions',
			size: ' File Size',
			uploadedByName: 'Uploaded By',
			createdAt: 'Created',
			url: 'URL',
		};
		const columnTypes = {
			name: 'text',
			dimensions: 'text',
			size: 'text',
			uploadedByName: 'text',
			createdAt: 'timestamp',
			url: 'link'
		};
		const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: columns[cfc],
				key: cfc,
				value: cfc,
				type: columnTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});
		this.state = {
			files: [],
			folderSelected: '',
			checkedFolders: [],
			loading: true,
			isGridLayout: true,
			addFilesModalOpen: false,
			removeFilesModalOpen: false,
			checkedFiles: {},
			searchSelected: false,
			columns: columns,
			columnTypes: columnTypes,
			normalizedColumns: normalizedColumns,
			toggledColumns: toggledColumns,
			searching: false,
			searchText: '',
			selectedSection: 0,
			searchedEntries: [],
			selectedColumnSort: null,
			sortDesc: false,
			toggleAddFolder: false,
			folders: [],
			filteredEntries: [],
			breadcrumbs: ['Event Files'],
			currentFolder: null, //id
			checkedAssets: {}
		};
	}

	componentDidMount() {
		const { eventId, orgId } = this.props;
		API().get(`Organizations/${orgId}/events/${eventId}/assets`, {
			params: {
				includeFolders: true
			}
		}).then(async (res) => {
			if (res.data) {

				let tempFiles = res.data.files || [];
				let folders = res.data.folders || [];


				for (let i = 0; i < tempFiles.length; i++) {
					let file = tempFiles[i];

					if (file.type.includes('image')) {
						await this.getImageDimensions(file.url).then((result) => {
							file.dimensions = `${result.width}x${result.height}`;
						}).catch((e) => {
							file.type = file.type.replace('image', 'file');
						});
					}
				}

				let tempFolders = folders.map((folder) => {
					return {
						...folder,
						isFolder: true,
					};
				});

				let filteredEntries = tempFiles.concat(tempFolders);
				//sort by  created date
				filteredEntries = filteredEntries.sort((a, b) => {
					return new Date(b.createdAt) - new Date(a.createdAt);
				});

				//filter all entries that has a parent folder
				let root = filteredEntries.filter((entry) => !entry.parentFolder);

				this.setState({ allFiles: tempFiles, allFolders: tempFolders, files: tempFiles, filteredEntries: root, loading: false });
			}
		});
	}

	getImageDimensions = (url) => {

		return new Promise((resolve, reject) => {
			let img = new Image();
			img.src = url;
			img.onload = function (e) {
				let width = img.width;
				let height = img.height;
				resolve({ width, height });
			}
			img.onerror = function (e) {
				reject(e);
			}
		})
	}

	addNewFiles = (files) => {
		const updatedFiles = this.state.allFiles.concat(files);

		let filteredEntries = this.state.filteredEntries.concat(files);
		filteredEntries = filteredEntries.sort((a, b) => {
			return new Date(b.createdAt) - new Date(a.createdAt);
		});

		this.setState({ allFiles: updatedFiles, filteredEntries: filteredEntries });

	};


	bytesToSize = (bytes) => {
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		//check if bytes contains a value from sizes array
		const match = sizes.find((size) => {
			return bytes.includes(size)

		});

		if (match) return bytes;
		if (bytes === 0) return 'n/a';
		const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
		if (i === 0) return `${bytes} ${sizes[i]}`;
		return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
	};

	toggleSearch = () => {
		this.setState({ searchSelected: !this.state.searchSelected });
	};

	toggleLayout = (selected) => {
		this.setState({ isGridLayout: selected });
	};

	checkAllFiles = () => {
		if (!this.state.allChecked) {
			const checkedFiles = {};
			this.state.files.forEach((f) => (checkedFiles[f._id] = true));
			this.setState({ checkedFiles: checkedFiles, allChecked: true });
		} else {
			this.setState({ checkedFiles: {}, allChecked: false });
		}
	};

	removeFiles = () => {
		const filteredFiles = this.state.files.filter((f) => !this.state.checkedFiles[f._id]);
		this.setState({ files: filteredFiles, checkedFiles: {}, allChecked: false }, () => {
			this.props.refreshSectionCounts();
		});
	};

	toggleDeleteFiles = () => {
		this.setState({ removeFilesModalOpen: true });
	};
	searchEntries = (searchText) => {
		this.setState({ searching: searchText !== '' ? true : false, searchText: searchText ? searchText : '' });
	};

	toggleAddFiles = () => {
		this.setState({ addFilesModalOpen: !this.state.addFilesModalOpen });
	};

	toggleRemoveFiles = () => {
		this.setState({ removeFilesModalOpen: !this.state.removeFilesModalOpen });
	};

	updatedCheckedFiles = (checked) => {
		this.setState({ checkedFiles: checked });
	};

	updateSelected = (selectedIndex) => {
		this.setState({ selectedSection: selectedIndex });
	};

	sortData = (column, sortAsc, sortDesc) => {
		const { normalizedColumns } = this.state;
		const updatedColumns = normalizedColumns.map((col) => {
			if (col.key === column.key) {
				col.sortAsc = sortAsc;
				col.sortDesc = sortDesc;
			} else {
				col.sortAsc = false;
				col.sortDesc = false;
			}
			return col;
		});

		this.setState({
			normalizedColumns: updatedColumns,
			selectedColumnSort: column,
			sortDesc: sortDesc ? true : false
		});
	};

	updateFavorite = (fileId, set) => {
		const { files } = this.state;

		const updatedFiles = files.map((file) => {
			if (file._id === fileId) {
				file.isFavorite = set;
			}
			return file;
		});
		this.setState({ files: updatedFiles });
	}
	toggleAddFolder = () => {
		this.setState({ toggleAddFolder: !this.state.toggleAddFolder });
	}

	addFolder = (folder, callback) => {
		const { allFolders } = this.state;
		allFolders.push(folder);
		this.setState({ allFolders: allFolders }, () => {
			this.handleFolderSelection(this.state.currentFolder);
			callback && callback();

		});

	}

	handleFolderSelection = (folderId) => {
		this.setState({ currentFolder: folderId }, () => {
			this.processData();
		});
	}

	processData = () => {
		const { allFiles, allFolders } = this.state;
		let filteredEntries = allFiles.concat(allFolders);
		let folderSelectionData = filteredEntries.filter((entry) => entry.parentFolder == this.state.currentFolder)
			.sort((a, b) => {
				return new Date(b.createdAt) - new Date(a.createdAt);
			}
			);

		this.setState({ filteredEntries: folderSelectionData }, () => {
			this.setBreadcrumbs();
		}
		);
	}

	handleBreadcrumbSelection = () => {
		const { allFiles, allFolders, currentFolder } = this.state;


		if (currentFolder) {
			//find folder by id
			let foundFolder = allFolders.find((folder) => folder._id == currentFolder);
			let parentFolder = foundFolder.parentFolder;

			this.setState({ currentFolder: parentFolder }, () => {
				this.processData();

			}
			);
		}
	}
	setBreadcrumbs = () => {

		const { currentFolder } = this.state;
		let breadcrumbs = [];
		let foundParentFolder = this.state.allFolders.find((folder) => folder._id == currentFolder);
		if (foundParentFolder) {
			breadcrumbs.push(foundParentFolder.name);
		}
		let isRoot = false;
		while (!isRoot) {
			if (foundParentFolder) {
				if (foundParentFolder.parentFolder) {
					let parentFolder = this.state.allFolders.find((folder) => folder._id == foundParentFolder.parentFolder);
					if (parentFolder) {
						breadcrumbs.push(parentFolder.name);
						foundParentFolder = parentFolder;
					} else {
						isRoot = true;
					}
				} else {
					isRoot = true;
				}
			} else {
				isRoot = true;
			}


		}

		breadcrumbs.push('Event Files');
		breadcrumbs.reverse();
		this.setState({ breadcrumbs: breadcrumbs });

	}


	removeAndUpdateAssets = async (files, folderList, callback) => {

		let tempFiles = files || [];
		let folders = folderList || [];

		for (let i = 0; i < tempFiles.length; i++) {
			let file = tempFiles[i];

			if (file.type.includes("image")) {
				await this.getImageDimensions(file.url).then((result) => {
					file.dimensions = `${result.width}x${result.height}`;
				});
			}
		}

		let tempFolders = folders.map((folder) => {
			return {
				...folder,
				isFolder: true,
			};
		});

		let filteredEntries = tempFiles.concat(tempFolders);
		//sort by  created date
		filteredEntries = filteredEntries.sort((a, b) => {
			return new Date(b.createdAt) - new Date(a.createdAt);
		});

		//filter all entries that has a parent folder
		let root = filteredEntries.filter((entry) => !entry.parentFolder);

		this.setState({ allFiles: tempFiles, allFolders: tempFolders, files: tempFiles, filteredEntries: root, checkedAssets: {}, checkedFolders: {}, checkedFiles: {} }, ()=>{
			this.handleFolderSelection();
			callback && callback();
		});

	}


	render() {
		const {
			files,
			folderSelected,
			addFilesModalOpen,
			removeFilesModalOpen,
			isGridLayout,
			columns,
			searching,
			searchText,
			toggledColumns,
			normalizedColumns,
			selectedSection,
			selectedColumnSort,
			sortDesc,
			loading,
			toggleAddFolder,
			filteredEntries,
			breadcrumbs,
			checkedAssets,
		} = this.state;
		const { event } = this.props;
		let searchedEntries = filteredEntries;

		//Searching by text from input
		if (searchText.length > 0) {
			const searchTerms = searchText.toLowerCase().split(' ');
			searchTerms.forEach((term) => {
				if (term !== '') {
					searchedEntries = searchedEntries.filter((entry) => {
						let found = false;
						Object.keys(columns).forEach((key) => {
							if (term !== '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
								found = true;
							}
						});
						return found;
					});
				}
			});
		}

		if (searchedEntries)
			searchedEntries = searchedEntries.map((file) => {
				if (!file.isFolder) {
					file.size = this.bytesToSize(file.size);
				}
				return file;
			});

		if (selectedSection === 1) {
			searchedEntries = searchedEntries.filter((file) => file.isFavorite);

		}

		if (selectedColumnSort) {
			searchedEntries = searchedEntries.sort((a, b) => {
				const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
				if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
					switch (columnType) {
						case 'string':
							return a[selectedColumnSort.key]
								.toLowerCase()
								.trim()
								.localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
						case 'number':
							return a[selectedColumnSort.key] - b[selectedColumnSort.key];
						case 'date':
							return (
								new Date(a[selectedColumnSort.key]).getTime() -
								new Date(b[selectedColumnSort.key]).getTime()
							);
						case 'time':
							return (
								new Date(a[selectedColumnSort.key]).getTime() -
								new Date(b[selectedColumnSort.key]).getTime()
							);
						case 'boolean':
							const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
							const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
							return a1.localeCompare(b1);
						default:
							return a[selectedColumnSort.key]
								.toLowerCase()
								.trim()
								.localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
					}
				} else if (a[selectedColumnSort.key]) {
					return 1;
				}
				return -1;
			});

			searchedEntries = sortDesc ? searchedEntries.reverse() : searchedEntries;
		}
		let mainAction = [];

		mainAction = [
			{ onClick: this.toggleAddFiles, label: "Add Files" },
			{ onClick: this.toggleAddFolder, label: "Add Folder" }
		];
		let batchActions = [];
		let checkedEntryCount = 0;
		let entriesLength = 0;
		let uncheckEntries = null;
		let searchEnabled = false;

		batchActions = [
			{
				type: 'button',
				label: 'Delete Files',
				onClick: this.toggleRemoveFiles,
				iconClass: 'las la-trash-alt',
				class: 'danger'
			}
		];
		checkedEntryCount = Object.keys(this.state.checkedFiles).length;
		entriesLength = searching || selectedSection === 1 ? searchedEntries.length : files.length;
		uncheckEntries = () => {
			this.setState({ checkedFiles: [] });
		};
		searchEnabled = true;
		return (
			<div className="sectionContainer">
				{!loading ? <div className="sectionContainer sectionBody">
					{((breadcrumbs && breadcrumbs.length > 0)) && (
						<div >
							{breadcrumbs &&
								breadcrumbs.length > 0 && (
									<div className={`flex ${breadcrumbs.length > 1 ? 'c-pointer' : ''}`} onClick={this.handleBreadcrumbSelection}>
										{breadcrumbs.map((b, i) => (
											<div key={i} className="breadCrumb flex-ac mb-5 ">
												{i > 0 && (
													<div className="breadCrumbSeparator ">
														<i className="las la-angle-right"></i>
													</div>
												)}
												<p className="small">
													{b}
												</p>
											</div>
										)
										)}
									</div>
								)}
						</div>
					)}
					<SectionHeader
						title={'Files'}
						description="Upload and manage files for your event."
						breadcrumbs={[]}
						style={{ paddingBottom: 0 }}
						enableLastLink={true}
					>

					</SectionHeader>
					<TabsContainer
						tabs={[{ title: 'All Files' }, { title: 'Favorites' }]}
						updateSelected={this.updateSelected}
						selectedIndex={selectedSection}
					/>
					{<ActionButtonContainer
						mainActions={mainAction}
						searchEnabled={searchEnabled}
						searchEntries={this.searchEntries}
						enabledViewSelection={true}
						isGridLayout={isGridLayout}
						toggleLayout={this.toggleLayout}
					/>}
					{!isGridLayout ? <ViewsTableAssets
						title={"Files"}
						columns={normalizedColumns}
						toggledColumns={toggledColumns}
						isGridLayout={isGridLayout}
						data={searchedEntries}
						updateFavorite={this.updateFavorite}
						orgId={this.props.orgId}
						mainColumnActive={false}
						checked={this.state.checkedFiles}
						checkRow={(entry) => {
							let entryId = entry._id;
							let isFolder = entry.isFolder;
							const checkedFolders = this.state.checkedFolders;
							if (isFolder) {
								checkedFolders[entryId]
									? delete checkedFolders[entryId]
									: (checkedFolders[entryId] = true);
								this.setState({
									checkedFolders: checkedFolders,
								});
							} else {
								checkedAssets[entryId]
									? delete checkedAssets[entryId]
									: (checkedAssets[entryId] = true);
								this.setState({
									checkedAssets: checkedAssets,
								});
							}

							const checked = this.state.checkedFiles;
							checked[entryId]
								? delete checked[entryId]
								: (checked[entryId] = true);
							this.updatedCheckedFiles(checked);
							this.setState({
								checkedFiles: checked,
							});
						}}
						mainActions={mainAction}
						checkAllRows={(entryIds) => {
							let checked = this.state.checkedFiles;
							entryIds.length > 0
								? entryIds.forEach((entryId) => {
									checked[entryId] = true;
								})
								: (checked = {});
							this.updatedCheckedFiles(checked);

							this.setState({
								checkedFiles: checked,
							});
						}}
						sortData={this.sortData}
						defaultSort={'name'}
						sortDirection={'desc'}
						enableImages={true}
						onClick={(rowId) => {
							let isFolder = searchedEntries.find((entry) => entry._id == rowId).isFolder;
							if (isFolder) {
								this.handleFolderSelection(rowId);
							}
						}}
					/> : <FileGrid
						title={"Files"}
						orgId={this.props.orgId}
						updateFavorite={this.updateFavorite}
						data={searchedEntries}
						checked={this.state.checkedFiles}
						hasFolders={true}
						checkRow={(entry) => {
							let entryId = entry._id;
							let isFolder = entry.isFolder;
							const checkedFolders = this.state.checkedFolders;
							if (isFolder) {
								checkedFolders[entryId]
									? delete checkedFolders[entryId]
									: (checkedFolders[entryId] = true);
								this.setState({
									checkedFolders: checkedFolders,
								});
							} else {
								checkedAssets[entryId]
									? delete checkedAssets[entryId]
									: (checkedAssets[entryId] = true);
								this.setState({
									checkedAssets: checkedAssets,
								});
							}

							const checked = this.state.checkedFiles;
							checked[entryId]
								? delete checked[entryId]
								: (checked[entryId] = true);
							this.updatedCheckedFiles(checked);
							this.setState({
								checkedFiles: checked,
							});
						}}
						handleFolderSelection={this.handleFolderSelection}
					/>}
					<ActionButtonContainer
						batchActions={batchActions}
						checkedEntryCount={checkedEntryCount}
						entriesLength={entriesLength}
						uncheckEntries={uncheckEntries}
					/>
				</div> : <LoadingWizard loading={loading} text="Loading Files" />}


				{addFilesModalOpen && (
					<FilesUploadModal
						isOpen={addFilesModalOpen}
						toggle={this.toggleAddFiles}
						folder={folderSelected}
						orgId={this.props.orgId}
						addFiles={this.addNewFiles}
						eventId={this.props.eventId}
						parentFolder={this.state.currentFolder}
					/>
				)}
				{toggleAddFolder && (
					<AddFolderModal
						isOpen={toggleAddFolder}
						toggle={this.toggleAddFolder}
						folder={folderSelected}
						orgId={this.props.orgId}
						eventId={this.props.eventId}
						addFolder={this.addFolder}
						parentFolder={this.state.currentFolder}
					/>
				)}
				{removeFilesModalOpen && (
					<RemoveFilesModal
						isOpen={removeFilesModalOpen}
						eventId={this.props.eventId}
						toggle={this.toggleRemoveFiles}
						orgId={this.props.orgId}
						removeFiles={this.removeFiles}
						files={Object.keys(this.state.checkedFiles)}
						folders={Object.keys(this.state.checkedFolders)}
						assets={Object.keys(checkedAssets)}
						removeAndUpdateAssets={this.removeAndUpdateAssets}
					/>
				)}
			</div>
		);
	}
}

export default EventFiles;
